// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { forceDownload } from '@fc-core/files-uploads/components/file-card/file-card.component';
import { NgButtonComponent } from '@fc-shared/ui/buttons/ng-button';

@Component({
  selector: 'fc-media-viewer-header',
  template: `
    <div
      class="flex flex-row items-center justify-between w-full px-24 md:px-30 py-16 md:py-24"
    >
      <div
        class="text-lg font-medium overflow-hidden text-ellipsis whitespace-nowrap text-white"
      >
        {{ file()?.name ?? 'Untitled' }}
      </div>

      <div class="flex flex-row items-center gap-8">
        <ng-button
          (click)="downloadFile()"
          variant="icon"
          icon="icon-download"
          color="white"
        />

        <ng-button
          [matMenuTriggerFor]="menu"
          variant="icon"
          icon="icon-more"
          color="white"
        />

        <ng-button
          (click)="closeDialog.emit()"
          variant="icon"
          icon="icon-close"
          color="white"
        />
      </div>
    </div>

    <mat-menu #menu="matMenu">
      <button (click)="openInfo.emit()" mat-menu-item>
        <fc-icon icon="icon-info-circle"></fc-icon>
        <span>Info</span>
      </button>

      @if (canDelete()) {
        <button mat-menu-item (click)="deleteFile.emit()">
          <fc-icon icon="icon-delete"></fc-icon>
          <span>Delete</span>
        </button>
      }
    </mat-menu>
  `,
  imports: [MatMenuModule, IconComponent, NgButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaViewerHeaderComponent {
  file = input<AttachmentModel>();
  canDelete = input<boolean>(false);
  openInfo = output<void>();
  closeDialog = output<void>();
  deleteFile = output<void>();

  downloadFile() {
    forceDownload(this.file()?.original, this.file()?.name);
  }
}
